import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="bg-white shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="text-xl font-bold text-blue-600">
            Pet Services SF
          </Link>
          <div className="flex space-x-6">
            <Link
              to="/services"
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              Services
            </Link>
            <Link
              to="/emergency"
              className="text-red-600 hover:text-red-700 transition-colors font-semibold"
            >
              Emergency
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 